import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecordContext, useGetOne } from "react-admin";
import { useState, useEffect } from "react";
import AnimatedBlock from "../../../components/Common/AnimatedBlock";
import InfoRow from "../../../components/Common/InfoRow";
import QuickViewCard from "../../../components/Common/QuickViewCard";
import { statusText } from "../../../components/Label";

const Stats = () => {
  const record = useRecordContext();
  const { data } = useGetOne("statsByProject", {
    id: record.id,
  });
  return data;
};

function RecentActivity() {
  const { t }: { t: any } = useTranslation();
  const [stats, setStats] = useState<any>({});

  const data = Stats();
  useEffect(() => {
    if (data) {
      setStats(data);
    }
  }, [data]);
  return (
    <QuickViewCard>
      <AnimatedBlock>
        <Typography variant="overline" color="text.secondary" component="div" sx={{ pt: 1 }}>
          {t("Total operations by status")}
        </Typography>
        {stats.data &&
          Object.entries(stats.data).map(([key, value]) => {
            // Ignorer la propriété id
            if (key === "id") return null;
            return (
              <InfoRow key={key} label={t(statusText(key.replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2")))}>
                <Box component="span" sx={{ fontVariantNumeric: "tabular-nums" }}>
                  {String(value)}
                </Box>
              </InfoRow>
            );
          })}
      </AnimatedBlock>
    </QuickViewCard>
  );
}

export default RecentActivity;
